"use strict";

import ItemView from "/js/interaction-views/item-view.js";
import QuestionnaireTextEntryItemContentView from "/js/interaction-views/questionnaire-text-entry-item-content-view.js";
import QuestionnaireMultipleChoiceItemContentView from "/js/interaction-views/questionnaire-multiple-choice-item-content-view.js";

/**
 * A single step in the questionnaire interaction.
 */
export default class QuestionnaireItemView extends ItemView {

  makeContentView(questionObject, index, numItems, answerObject=null) {
    var view;
    if (questionObject.type === "text-entry") {
      view = new QuestionnaireTextEntryItemContentView(questionObject, index, numItems, answerObject);
    } else if (questionObject.type === "multiple-choice") {
      view = new QuestionnaireMultipleChoiceItemContentView(questionObject, index, numItems);
    } else {
      cl("Bad type value:", questionObject);
    }
    return view;
  }
}
